import { defineMessages } from '@transcend-io/internationalization';

export const sidebarMessages = defineMessages(
  'privacy-center.containers.Sidebar.sidebar',
  {
    navLabel: { defaultMessage: 'Sidebar' },
    routeSkipLinkText: { defaultMessage: 'Skip to {title}' },
  },
);
